<app-reportable-popup-shell
  [paragraphHeadingText]="
    properties.telematorId + ' ' + '(' + properties.name + ')'
  "
  [status]="status"
  [isLoading]="pdfController.isPdfDownloadInProgress"
  [downloadTooltipLabel]="downloadTooltipLabel"
  [primaryButtonText]="'report.open'"
  [secondaryButtonText]="'close'"
  [incomingDucts]="properties.incomingDucts"
  [outgoingDucts]="properties.outgoingDucts"
  (trigger)="onDownloadPreviewPdf($event)"
  (triggerKeydown)="onDownloadPreviewPdfKeyDown($event)"
  (primaryButtonClick)="openReport()"
  (secondaryButtonClick)="onClosePopup()"
/>
